import Img from "images/sprinter.png";
import { useNavigate } from "react-router-dom";
import ButtonPrimary from "shared/Button/ButtonPrimary";

const packages = [
  { title: "Wine Tour", duration: "4hrs." },
  { title: "Quinceanera", duration: "8hrs." },
  { title: "Wedding", duration: "" },
  { title: "Bachelor/ Bachelorette Party", duration: "" },
  { title: "Concert", duration: "5hrs." },
  { title: "Ladies/Guy's Night Out", duration: "5hrs." },
];

export default function SprinterPricing() {
  const navigate = useNavigate();
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 p-8 items-center">
      <div className="flex flex-col space-y-6">
        <h2 className="text-4xl font-bold max-w-xl leading-snug">
          Package Pricing For Sprinters:
        </h2>
        <div className="relative">
          <img src={Img} alt="Sprinter vehicles" className="rounded-lg" />
        </div>
      </div>

      <div className="bg-white py-12 px-6 rounded-2xl shadow-lg w-full flex flex-col">
        <ul className="space-y-8 text-lg font-medium text-gray-800">
          {packages.map((pkg, i) => (
            <li key={i} className="flex items-center gap-3">
              <span>
                <svg
                  width="32"
                  height="31"
                  viewBox="0 0 32 31"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M30 15.5C30 7.77083 23.7292 1.5 16 1.5C8.27083 1.5 2 7.77083 2 15.5C2 23.2292 8.27083 29.5 16 29.5C23.7292 29.5 30 23.2292 30 15.5Z"
                    stroke="#FF0000"
                    stroke-width="3"
                    stroke-miterlimit="10"
                  />
                  <path
                    d="M23 9.6665L13.2 21.3332L9 16.6665"
                    stroke="#FF0000"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
              {pkg.title}
            </li>
          ))}
        </ul>
        <ButtonPrimary onClick={() => navigate("/events")} className="mt-12">
        Reserve Your Date
        </ButtonPrimary>
      </div>
    </div>
  );
}
